<div class="modal-body">
  <app-flash-notifications></app-flash-notifications>

  <div class="d-flex align-item-center justify-content-center mb-4">
    <svg style="color: #9fb0c7;" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      class="lucide lucide-mail-check-icon lucide-mail-check">
      <path d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
      <path d="m16 19 2 2 4-4" />
    </svg>
  </div>

  <h2 class="text-center">
    Please verify your email.
  </h2>

  <p class="text-body-secondary text-center mx-5">
    Welcome to Openbridge. Upon registration you should have received an email at
    <strong>"{{authEmail}}"</strong> requesting you verify your account email
    address. <br>
    If you did not receive it please check any spam folders.<br>
    If you are still unable to find it you can request us send it again.<br>
    Once your email is verified <a href class="light-link" (click)="refreshUser()">reload our app</a> to continue.
  </p>


  <div class="d-flex align-items-center justify-content-center mt-2">
    <button class="btn btn-primary" type="button" [disabled]="isLoading" (click)="resendVerificationEmail()">
      @if (!isLoading) {
        Resend verification email
      } @else {
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      }
    </button>
  </div>

  @if (verificationEmailResent && !isLoading;) {
    <div class="text-center mt-3" style="color: #1d9160;">
      Verification email has been resent. <br>
      If you do not see it, please make sure to check your spam folder.
    </div>
  }

  <!-- Divider -->
  <div class="w-50 text-center mx-auto">
    <div class="position-relative">
      <hr class="bg-200 my-5" style="border-top: 2px dashed;">
      <div class="divider-content-center">
        OR
      </div>
    </div>
  </div>

  <p class="text-body-secondary text-center mx-5">
    Oops! Signed in with the wrong account or can’t check that email? <br>
    No biggie — just <a (click)="signOut()" class="light-link"> sign out </a> and swing back in when you’re ready!
  </p>

</div>